const getRandomIntegerNumber = (min = 0, max = 7) => {
  return (min + Math.floor(Math.random() * (max + 1 - min) + min));
}

export {
  getRandomIntegerNumber,
};
